
// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import Sidebar from "./components/Sidebar";
// import Header from "./components/Header";
// import { RequestProvider } from "./components/RequestContext"; 
// import Dashboard from "./components/Dashboard";
// import RequestTable from "./components/AllRequest.js";
// import Transaction from "./components/transaction-details";
// import PropertyInfo from "./components/property-infor";
// import ClientCounterparty from "./components/ClientCounterparty";
// import CorporateStructure from "./components/CorporateStructure";
// import ManagementStructureForm from "./components/management-structure";
// import RiskAsses from "./components/risk-assement";
// import RiskAssesContinue from "./components/riskassessmentContinue";
// import EDD from "./components/edd";
// import FinalReview from "./components/final-review";
// import FinalReport from "./components/report"
// import { UserProvider } from "./components/userContext";
// import AdminUser from "./components/AdminUser";
// import CodAddmin from "./components/COD-admin";
// import UnauthorizedAccess from "./components/UnauthorizedAccess";
// import ProtectedRoute from "./components/ProtectedRoute";
// import "./App.css";
// import LoadingGate from "./components/loadingGate.js";
// import { userSession } from "./observers/userObserver.js";


// const App = () => {




//   const [userType, setUserType] = useState("");

//   // Subscribe to user type from session observer
//   useEffect(() => {
//     const unsubscribe = userSession.subscribe((user, _) => {
//       console.log("User cod Type:", user.userType);
//       setUserType(user.userType?.toLowerCase()); // Ensure lowercase for consistency
//     });

//     return () => {
//       unsubscribe();
//     };
//   }, []);
//   return (
//     <UserProvider>
//       <RequestProvider>
//         <Router>
//           <div className="app">
//             <Sidebar />
//             <div className="main-content">
//               <Header />
//               <Routes>
//                 {/* Default Route */}
//                 <Route path="/" element={<Navigate to="/dashboard" />} />

//                 {/* Defined Routes */}
//                 <Route path="/dashboard" element={<LoadingGate><Dashboard /></LoadingGate>} />
//                 <Route path="/transaction-detail" element={<Transaction />} />
//                 <Route path="/all-requests" element={<RequestTable />} />
//                 <Route path="/property-info" element={<PropertyInfo />} />
//                 <Route path="/client-counter" element={<ClientCounterparty />} />
//                 <Route path="/corporate-structure" element={<CorporateStructure />} />
//                 <Route path="/management-structure" element={<ManagementStructureForm />} />
//                 <Route path="/RiskAsses" element={<RiskAsses/>}/>
//                 <Route path="/RiskAssesContinue" element={<RiskAssesContinue/>}/>
//                 <Route path="/Edd" element={<EDD/>}/>
//                 <Route path="/FinalReview" element={<FinalReview/>}/>
//                 <Route path="/Report" element={<FinalReport/>}/>
//                 <Route path="/restricted" element={<UnauthorizedAccess />} />
//                 {/* <Route path="/AdminUser" element={<AdminUser/>}/>
//                 <Route path="/CodAdmin" element={<CodAddmin/>}/> */}
//                  <Route
//           path="/AdminUser"
//           element={
//             <ProtectedRoute usertype={userType} allowedType="ADMN">
//              <AdminUser/>
//             </ProtectedRoute>
//           }
//         />
//                  <Route
//           path="/CodAdmin"
//           element={
//             <ProtectedRoute usertype={userType} allowedType="COD">
//               <CodAddmin/>
//             </ProtectedRoute>
//           }
//         />
//               </Routes>
//             </div>
//           </div>
//         </Router>
//       </RequestProvider>
//     </UserProvider>
//   );
// };

// export default App;



import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import { RequestProvider } from "./components/RequestContext";
import Dashboard from "./components/Dashboard";
import RequestTable from "./components/AllRequest.js";
import Transaction from "./components/transaction-details";
import PropertyInfo from "./components/property-infor";
import ClientCounterparty from "./components/ClientCounterparty";
import CorporateStructure from "./components/CorporateStructure";
import ManagementStructureForm from "./components/management-structure";
import RiskAsses from "./components/risk-assement";
import RiskAssesContinue from "./components/riskassessmentContinue";
import EDD from "./components/edd";
import FinalReview from "./components/final-review";
import FinalReport from "./components/report";
import AdminUser from "./components/AdminUser";
import CodAdmin from "./components/COD-admin";
import UnauthorizedAccess from "./components/UnauthorizedAccess";
import ProtectedRoute from "./components/ProtectedRoute";
import AdverseMediaSearch from "./components/AdverseMediaSearchCod.js";
import LoginEmail from "./components/login/LoginEmail.js";
import LoginPassword from "./components/login/LoginPassword.js";
import ForgotPassword from "./components/login/ForgotPassword.js";
import EnterOtp from "./components/login/EnterOtp.js";
import EnterTotp from "./components/login/EnterTotp.js";
import TotpSetup from "./components/login/TotpSetup.js";
import ChangePassword from "./components/login/ChangePassword.js";
import SignupEmail from "./components/login/SignupEmail.js";
import SignupPassword from "./components/login/SignupPassword.js";
import "./App.css";
import Report3 from "./components/Report3.js";
import Report4 from "./components/Report4.js";
import Report5 from "./components/Report5.js";
import { UserSessionProvider } from "./context/userSession.js";
import { userSession } from "./observers/userObserver.js";
import { TooltipProvider } from "./hooks/toolTips.js";

const App = () => {
  const [userType, setUserType] = useState("");

  // Subscribe to user type from session observer
  useEffect(() => {
    const unsubscribe = userSession.subscribe((user) => {
      const type = user.userType?.toLowerCase();
      console.log("User cod Type:", type);
      setUserType(type);
    }, []);

    return () => {
      unsubscribe();
    };
  }, []);

  const AppLayout = () => (
    <div className="app">
      <Sidebar />
      <div className="main-content">
        <Header />
        <Routes>
          {/* Defined Routes */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/transaction-detail" element={<Transaction />} />
          <Route path="/all-requests" element={<RequestTable />} />
          <Route path="/property-info" element={<PropertyInfo />} />
          <Route path="/client-counter" element={<ClientCounterparty />} />
          <Route path="/corporate-structure" element={<CorporateStructure />} />
          <Route path="/management-structure" element={<ManagementStructureForm />} />
          <Route path="/RiskAsses" element={<RiskAsses />} />
          <Route path="/RiskAssesContinue" element={<RiskAssesContinue />} />
          <Route path="/Edd" element={<EDD />} />
          <Route path="/FinalReview" element={<FinalReview />} />
          <Route path="/restricted" element={<UnauthorizedAccess />} />
          <Route path="/AdverseSearch" element={<AdverseMediaSearch />} />
          {/* <Route path="/report2" element={<Report2 />} /> */}
          <Route path="/Report" element={<FinalReport />} />
          {/* <Route path="/report3" element={<Report3 />} /> */}
          <Route path="/report3" element={<Report5 />} />

          {/* Protected Routes */}
          <Route
            path="/AdminUser"
            element={
              <ProtectedRoute allowedType="ADMN">
                <AdminUser />
              </ProtectedRoute>
            }
          />
          {/* <Route path="/AdminUser" element={<AdminUser />} /> */}
          <Route
            path="/COnDAdmin"
            element={
              <ProtectedRoute allowedType="COD">
                <CodAdmin />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </div>
  );

  return (
    <Router>
      <Routes>
        {/* Default: redirect root to login */}
        <Route path="/" element={<Navigate to="/login" replace />} />

        {/* Login / Auth Routes - No Sidebar, Header, or Session required */}
        <Route path="/login" element={<LoginEmail />} />
        <Route path="/login-password" element={<LoginPassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/enter-otp" element={<EnterOtp />} />
        <Route path="/enter-totp" element={<EnterTotp />} />
        <Route path="/totp-setup" element={<TotpSetup />} />
        <Route path="/change-password/:token" element={<ChangePassword />} />
        <Route path="/update_password/:token" element={<ChangePassword />} />
        <Route path="/signup" element={<SignupEmail />} />
        <Route path="/signup-password" element={<SignupPassword />} />

        {/* All other routes - With Sidebar, Header, and Session */}
        <Route path="/*" element={
          <UserSessionProvider>
            <RequestProvider>
              <TooltipProvider>
                <AppLayout />
              </TooltipProvider>
            </RequestProvider>
          </UserSessionProvider>
        } />
      </Routes>
    </Router>
  );
};

export default App;
